import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultOpen", "linkHook"];
import React, { forwardRef } from 'react';
import { Modal as CarnicaModal } from '@carnica/ui-kit';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect, usePopupLinkListener } from "../../utils";
var closeOptions = {
  button: true,
  escape: true,
  overlay: true
};
var _AutoModal = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var defaultOpen = _ref.defaultOpen,
    linkHook = _ref.linkHook,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePopupLinkListener = usePopupLinkListener(linkHook, defaultOpen),
    _usePopupLinkListener2 = _slicedToArray(_usePopupLinkListener, 2),
    isOpen = _usePopupLinkListener2[0],
    setIsOpen = _usePopupLinkListener2[1];
  return /*#__PURE__*/React.createElement(CarnicaModal, _extends({}, props, {
    closeOptions: closeOptions,
    isOpen: isOpen,
    onClose: setIsOpen.off,
    ref: ref,
    "data-t-id": "components-AutoModal"
  }));
});
export var AutoModal = compose(enhancedConnect(), withAutoMetric.Container(function (props) {
  return {
    name: 'Modal',
    linkHook: props.linkHook
  };
}, {
  asChildRef: true
}))(_AutoModal);